import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

import CropRow from './CropRow';
import { addCrop } from '@modules/editor';

function CropMenu() {
    const { t } = useTranslation();
    const cropList = useSelector((state: any) => state.editor.cropList);
    const dispatch = useDispatch();

    const [tmpCropList, setTmpCropList] = useState<any>({});

    useEffect(() => {
        if (Object.keys(cropList).length > 0) {
            setTmpCropList(cropList);
        } else {
            setTmpCropList({});
        }
    }, [cropList]);

    function addCropItem() {
        if (Object.keys(cropList).length === 0) {
            const newCrop = {
                "x": 100,
                "y": 100,
                "width": 200,
                "height": 200
            };
            dispatch(addCrop(newCrop));
        }
    }

    return (
        <div className='crop-menu'>
            <div className='menu-box'>
                {tmpCropList && Object.keys(tmpCropList).length > 0 && (
                    <CropRow />
                )}
                {Object.keys(cropList).length === 0 && (
                    <IconButton className="add-button" onClick={addCropItem}>
                        <AddIcon />
                        <Typography variant="body1">{t('vod.manage.editor_tab.add_crop')}</Typography>
                    </IconButton>
                )}
            </div>
        </div>
    );
}

export default CropMenu;
